// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.BlogList_blog-list__mm54o {
  width: 100%;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
  display: flex;
  flex-direction: column;
}
.BlogList_blog-list__table-container__Vnbq8 {
  width: 100%;
}
.BlogList_blog-list__utility-bar__MqXKZ {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin-bottom: 24px;
}
@media (max-width: 768px) {
  .BlogList_blog-list__utility-bar__MqXKZ {
    margin-top: -8px;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
  .BlogList_blog-list__utility-bar__MqXKZ .BlogList_blog-list__add-btn__GpltI {
    width: 100%;
  }
}
.BlogList_blog-list__header__sWP4Q {
  margin-bottom: 8px;
}
.BlogList_blog-list__eyebrow__RCbrO {
  display: block;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #82B194;
  margin-bottom: 8px;
}
.BlogList_blog-list__title__qKQfl {
  margin: 0;
  font-size: 32px;
  font-weight: 800;
  color: #13231D;
  letter-spacing: -0.03em;
}
.BlogList_blog-list__add-btn__GpltI {
  min-height: 48px !important;
  padding: 0 24px !important;
}
.BlogList_blog-list__filters__D\\+a4p {
  width: 100%;
}
.BlogList_blog-list__error__HP-0n {
  background-color: #FEF2F2;
  color: #C95C5C;
  padding: 16px;
  border-radius: 16px;
  text-align: center;
  font-weight: 700;
  border: 1px solid rgba(201, 92, 92, 0.1);
}

@media (max-width: 1024px) {
  .BlogList_blog-list__title__qKQfl {
    font-size: 28px;
  }
}
@media (max-width: 768px) {
  .BlogList_blog-list__title__qKQfl {
    font-size: 24px;
  }
  .BlogList_blog-list__header__sWP4Q {
    margin-bottom: 20px;
  }
  .BlogList_blog-title-cell__lU4Wo {
    flex-direction: row-reverse;
    justify-content: flex-start;
    align-items: center;
    text-align: right;
    max-width: 70%;
    gap: 12px;
  }
  .BlogList_blog-title-cell__text__Ss2kQ {
    font-size: 13px;
    max-width: none;
  }
  .BlogList_blog-thumb__sRtGo {
    width: 40px !important;
    height: 40px !important;
    border-radius: 8px !important;
  }
  .BlogList_status-tag__JOxMQ {
    font-size: 9px;
    padding: 2px 8px;
  }
  .BlogList_icon-action-btn__xfhu9 {
    width: 32px;
    height: 32px;
    border-radius: 8px;
  }
}
@media (max-width: 480px) {
  .BlogList_blog-list__title__qKQfl {
    font-size: 11px;
  }
  .BlogList_blog-title-cell__lU4Wo {
    max-width: 100%;
  }
}
.BlogList_blog-title-cell__lU4Wo {
  display: flex;
  align-items: center;
  gap: 16px;
}
.BlogList_blog-title-cell__text__Ss2kQ {
  font-weight: 700;
  color: #13231D;
  font-size: 14px;
  line-height: 1.4;
  max-width: 300px;
}

.BlogList_blog-thumb__sRtGo {
  width: 52px;
  height: 52px;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid rgba(16, 25, 21, 0.08);
  background-color: #eee;
  flex-shrink: 0;
}

.BlogList_status-tag__JOxMQ {
  display: inline-flex;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.BlogList_status-tag--published__RW7in {
  background: #E9F4EF;
  color: #4E997C;
}
.BlogList_status-tag--draft__JuR-s {
  background: #F1F5F9;
  color: #64748B;
}

.BlogList_actions-wrapper__zSssi {
  display: flex;
  gap: 8px;
}

.BlogList_icon-action-btn__xfhu9 {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(16, 25, 21, 0.08);
  background: #fff;
  color: rgba(19, 35, 29, 0.68);
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.BlogList_icon-action-btn__xfhu9:hover {
  background: #82B194;
  color: #fff;
  border-color: transparent;
  transform: translateY(-2px);
}
.BlogList_icon-action-btn--delete__oOoaA:hover {
  background: #FEF2F2;
  color: #C95C5C;
  border-color: rgba(201, 92, 92, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/BlogList/BlogList.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AANA;EACI,WAAA;EACA,oFDNQ;ECOR,aAAA;EACA,sBAAA;AASJ;AANI;EACI,WAAA;AAQR;AALI;EACI,aAAA;EACA,2BAAA;EACA,qBAAA;EACA,mBAAA;AAOR;AALQ;EANJ;IAOQ,gBAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;EAQV;EANU;IACI,WAAA;EAQd;AACF;AAJI;EACI,kBAAA;AAMR;AAHI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDtCe;ECuCf,kBAAA;AAKR;AAFI;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cDjCe;ECkCf,uBAAA;AAIR;AADI;EACI,2BAAA;EACA,0BAAA;AAGR;AAAI;EACI,WAAA;AAER;AACI;EACI,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AACR;;AAIA;EAEQ;IACI,eAAA;EAFV;AACF;AAMA;EAEQ;IACI,eAAA;EALV;EAQM;IACI,mBAAA;EANV;EAUE;IACI,2BAAA;IACA,2BAAA;IACA,mBAAA;IACA,iBAAA;IACA,cAAA;IACA,SAAA;EARN;EAUM;IACI,eAAA;IACA,eAAA;EARV;EAYE;IACI,sBAAA;IACA,uBAAA;IACA,6BAAA;EAVN;EAaE;IACI,cAAA;IACA,gBAAA;EAXN;EAcE;IACI,WAAA;IACA,YAAA;IACA,kBAAA;EAZN;AACF;AAeA;EAEQ;IACI,eAAA;EAdV;EAkBE;IACI,eAAA;EAhBN;AACF;AAmBA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAjBJ;AAmBI;EACI,gBAAA;EACA,cDhIe;ECiIf,eAAA;EACA,gBAAA;EACA,gBAAA;AAjBR;;AAqBA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;EACA,sBAAA;EACA,cAAA;AAlBJ;;AAqBA;EACI,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAlBJ;AAoBI;EACI,mBAAA;EACA,cAAA;AAlBR;AAqBI;EACI,mBAAA;EACA,cAAA;AAnBR;;AAuBA;EACI,aAAA;EACA,QAAA;AApBJ;;AAuBA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,gBAAA;EACA,6BD9KmB;EC+KnB,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AApBJ;AAsBI;EACI,mBDpMe;ECqMf,WAAA;EACA,yBAAA;EACA,2BAAA;AApBR;AAuBI;EACI,mBAAA;EACA,cAAA;EACA,oCAAA;AArBR","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n$bw-primary: $color-primary;\n$bw-text: $text-main;\n$bw-muted: $text-secondary;\n$bw-border: $color-border;\n$bw-surface: $color-surface;\n$bw-radius-xl: $border-radius;\n$bw-shadow: $shadow-card;\n\n.blog-list {\n    width: 100%;\n    font-family: $font-main;\n    display: flex;\n    flex-direction: column;\n    // gap: 24px;\n    \n    &__table-container {\n        width: 100%;\n    }\n    \n    &__utility-bar {\n        display: flex;\n        justify-content: flex-start;\n        align-items: flex-end;\n        margin-bottom: 24px;\n\n        @media (max-width: 768px) {\n            margin-top: -8px;\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 20px;\n            \n            .blog-list__add-btn {\n                width: 100%;\n            }\n        }\n    }\n\n    &__header {\n        margin-bottom: 8px;\n    }\n\n    &__eyebrow {\n        display: block;\n        font-size: 11px;\n        font-weight: 800;\n        text-transform: uppercase;\n        letter-spacing: 0.14em;\n        color: $bw-primary;\n        margin-bottom: 8px;\n    }\n\n    &__title {\n        margin: 0;\n        font-size: 32px;\n        font-weight: 800;\n        color: $bw-text;\n        letter-spacing: -0.03em;\n    }\n\n    &__add-btn {\n        min-height: 48px !important;\n        padding: 0 24px !important;\n    }\n\n    &__filters {\n        width: 100%;\n    }\n\n    &__error {\n        background-color: #FEF2F2;\n        color: #C95C5C;\n        padding: 16px;\n        border-radius: 16px;\n        text-align: center;\n        font-weight: 700;\n        border: 1px solid rgba(201, 92, 92, 0.1);\n    }\n}\n\n\n@media (max-width: 1024px) {\n    .blog-list {\n        &__title {\n            font-size: 28px;\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .blog-list {\n        &__title {\n            font-size: 24px;\n        }\n\n        &__header {\n            margin-bottom: 20px;\n        }\n    }\n\n    .blog-title-cell {\n        flex-direction: row-reverse;\n        justify-content: flex-start;\n        align-items: center;\n        text-align: right;\n        max-width: 70%;\n        gap: 12px;\n\n        &__text {\n            font-size: 13px;\n            max-width: none;\n        }\n    }\n\n    .blog-thumb {\n        width: 40px !important;\n        height: 40px !important;\n        border-radius: 8px !important;\n    }\n\n    .status-tag {\n        font-size: 9px;\n        padding: 2px 8px;\n    }\n\n    .icon-action-btn {\n        width: 32px;\n        height: 32px;\n        border-radius: 8px;\n    }\n}\n\n@media (max-width: 480px) {\n    .blog-list {\n        &__title {\n            font-size: 11px;\n        }\n    }\n\n    .blog-title-cell {\n        max-width: 100%;\n    }\n}\n\n.blog-title-cell {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    \n    &__text {\n        font-weight: 700;\n        color: $bw-text;\n        font-size: 14px;\n        line-height: 1.4;\n        max-width: 300px;\n    }\n}\n\n.blog-thumb {\n    width: 52px;\n    height: 52px;\n    object-fit: cover;\n    border-radius: 12px;\n    border: 1px solid $bw-border;\n    background-color: #eee;\n    flex-shrink: 0;\n}\n\n.status-tag {\n    display: inline-flex;\n    padding: 4px 12px;\n    border-radius: 999px;\n    font-size: 10px;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    \n    &--published {\n        background: #E9F4EF;\n        color: #4E997C;\n    }\n    \n    &--draft {\n        background: #F1F5F9;\n        color: #64748B;\n    }\n}\n\n.actions-wrapper {\n    display: flex;\n    gap: 8px;\n}\n\n.icon-action-btn {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    border: 1px solid $bw-border;\n    background: #fff;\n    color: $bw-muted;\n    display: grid;\n    place-items: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n        background: $bw-primary;\n        color: #fff;\n        border-color: transparent;\n        transform: translateY(-2px);\n    }\n\n    &--delete:hover {\n        background: #FEF2F2;\n        color: #C95C5C;\n        border-color: rgba(201, 92, 92, 0.2);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blog-list": `BlogList_blog-list__mm54o`,
	"blog-list__table-container": `BlogList_blog-list__table-container__Vnbq8`,
	"blog-list__utility-bar": `BlogList_blog-list__utility-bar__MqXKZ`,
	"blog-list__add-btn": `BlogList_blog-list__add-btn__GpltI`,
	"blog-list__header": `BlogList_blog-list__header__sWP4Q`,
	"blog-list__eyebrow": `BlogList_blog-list__eyebrow__RCbrO`,
	"blog-list__title": `BlogList_blog-list__title__qKQfl`,
	"blog-list__filters": `BlogList_blog-list__filters__D+a4p`,
	"blog-list__error": `BlogList_blog-list__error__HP-0n`,
	"blog-title-cell": `BlogList_blog-title-cell__lU4Wo`,
	"blog-title-cell__text": `BlogList_blog-title-cell__text__Ss2kQ`,
	"blog-thumb": `BlogList_blog-thumb__sRtGo`,
	"status-tag": `BlogList_status-tag__JOxMQ`,
	"icon-action-btn": `BlogList_icon-action-btn__xfhu9`,
	"status-tag--published": `BlogList_status-tag--published__RW7in`,
	"status-tag--draft": `BlogList_status-tag--draft__JuR-s`,
	"actions-wrapper": `BlogList_actions-wrapper__zSssi`,
	"icon-action-btn--delete": `BlogList_icon-action-btn--delete__oOoaA`
};
export default ___CSS_LOADER_EXPORT___;
